import { Link } from "react-router-dom";
import { Facebook, Instagram, MapPin, Mail } from "lucide-react";
import { creches, isPlaceholder } from "../data/creches";
import { site, PREINSCRIPTION_URL } from "../data/site";

export default function Footer() {
  return (
    <footer className="border-t border-edge-soft bg-muted/40 mt-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-3">
          <Link to="/" className="inline-block mb-4" aria-label="La La Land — Accueil">
            <img
              src="/images/logo-lalaland.png"
              alt="La La Land micro-crèches"
              className="h-16 w-auto"
              width={800}
              height={518}
            />
          </Link>
          <p className="text-sm text-ink-soft leading-relaxed">
            Nos micro-crèches en Normandie. La musique au cœur du développement
            de vos enfants.
          </p>
          <a
            href={`mailto:${site.organization.contactEmail}`}
            className="mt-4 inline-flex items-center gap-2 text-sm text-ink-soft hover:text-terra"
          >
            <Mail size={14} strokeWidth={1.7} />
            {site.organization.contactEmail}
          </a>
        </div>

        <div className="md:col-span-2">
          <h3 className="text-sm font-semibold uppercase tracking-wider text-ink mb-4">
            Pages
          </h3>
          <ul className="space-y-2 text-sm text-ink-soft">
            <li>
              <Link to="/nos-micro-creches" className="hover:text-terra">
                Nos micro-crèches
              </Link>
            </li>
            <li>
              <Link to="/tarifs" className="hover:text-terra">
                Tarifs
              </Link>
            </li>
            <li>
              <a
                href={PREINSCRIPTION_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-terra"
              >
                Pré-inscription
              </a>
            </li>
            <li>
              <Link to="/entreprises" className="hover:text-terra">
                Entreprises
              </Link>
            </li>
            <li>
              <Link to="/nous-rejoindre" className="hover:text-terra">
                Recrutement
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-5">
          <h3 className="text-sm font-semibold uppercase tracking-wider text-ink mb-4">
            Nos micro-crèches
          </h3>
          <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-5 text-sm">
            {creches.map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/micro-creches/${c.slug}`}
                  className="group block rounded-xl -m-2 p-2 hover:bg-white/60 transition-colors"
                >
                  <p className="font-semibold text-ink group-hover:text-terra leading-tight transition-colors">
                    {c.nom}
                  </p>
                  <p className="text-xs text-ink-muted/90 leading-snug mt-1 inline-flex items-start gap-1">
                    <MapPin
                      size={11}
                      strokeWidth={1.7}
                      className="mt-0.5 shrink-0"
                    />
                    <span>
                      {c.adresse} · {c.codePostal} {c.ville}
                    </span>
                  </p>
                  {!isPlaceholder(c.email) && (
                    <p className="text-xs text-sage-hover mt-0.5 truncate">
                      {c.email}
                    </p>
                  )}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <h3 className="text-sm font-semibold uppercase tracking-wider text-ink mb-4">
            Légal & social
          </h3>
          <ul className="space-y-2 text-sm text-ink-soft">
            <li>
              <Link to="/mentions-legales" className="hover:text-terra">
                Mentions légales
              </Link>
            </li>
            <li>
              <Link to="/reseaux-sociaux" className="hover:text-terra">
                Réseaux sociaux
              </Link>
            </li>
            <li>
              <a
                href={site.socialLinks.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 hover:text-terra"
              >
                <Instagram size={16} strokeWidth={1.5} />
                Instagram
              </a>
            </li>
            <li>
              <a
                href={site.socialLinks.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 hover:text-terra"
              >
                <Facebook size={16} strokeWidth={1.5} />
                Facebook
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-edge-soft">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 text-xs text-ink-muted flex flex-wrap items-center justify-between gap-3">
          <p>© {new Date().getFullYear()} La La Land — Tous droits réservés</p>
          <p>Normandie · Made with care</p>
        </div>
      </div>
    </footer>
  );
}
